<div class="mb-1">
  @if (rendering?.subtitle) {
    <p>{{ rendering?.subtitle }}</p>
  }
</div>
<form
  novalidate
  [ngrxFormState]="formState"
  [wlTrackStep]="{
    rendering: { componentName: 'verbruik inschatten' },
    step: 0.1,
    stepName: 'verbruik inschatten',
  }"
>
  <div class="mb-2">
    @if (useAccessibleCalculator) {
      <crnt-form-control>
        <crnt-select>
          <select
            [wlTrackValueChange]="{
              step: 0.1,
              rendering: { componentName: 'verbruik inschatten' },
              label: 'aantal personen',
              inputLabel: formControls.residents?.value || '',
              sendValue: true,
              trackFocus: true,
              stepName: 'verbruik inschatten',
            }"
            [id]="formControls.residents?.id"
            wlAutomationId="usageQuestionnaire.residents"
            [ngrxFormControlState]="formControls.residents"
          >
            @for (
              residentOption of rendering?.residentsOptions;
              track residentOption.value
            ) {
              <option [value]="residentOption.value">
                {{ residentOption.label }}
              </option>
            }
          </select>
          <crnt-icon icon="user" slot="leading"></crnt-icon>
        </crnt-select>
        <crnt-form-control-label slot="label">
          <label [for]="formControls.residents?.id" class="fw-normal">
            {{ rendering?.residentsOptionsLabel }}
          </label>
        </crnt-form-control-label>
        @if (formControls.residents | isInvalid) {
          <crnt-form-control-validation-message slot="validation">
            {{ rendering?.errorMessage }}
          </crnt-form-control-validation-message>
        }
      </crnt-form-control>
    } @else {
      <div class="mb-2">
        @if (rendering?.residentsOptionsLabel) {
          <label for="residents">
            {{ rendering?.residentsOptionsLabel }}
          </label>
        }
        <wl-dropdown
          [wlTrackValueChange]="{
            step: 0.1,
            rendering: { componentName: 'verbruik inschatten' },
            label: 'aantal personen',
            inputLabel: formControls.residents?.value || '',
            sendValue: true,
            trackFocus: true,
            stepName: 'verbruik inschatten',
          }"
          [dropdownItems]="rendering?.residentsOptions"
          [formsControl]="formControls.residents"
          [placeholder]="rendering?.residentsOptionsPlaceHolder"
          [floatingLabel]="false"
          icon="user"
          labelForId="residents"
          wlAutomationId="usageQuestionnaire.residents"
        ></wl-dropdown>
      </div>
      @if (formControls.residents | isInvalid) {
        <div class="col-12">
          <wl-input-error
            [messageField]="rendering?.errorMessage"
            messageDescription="aantal personen"
            [rendering]="rendering"
            stepName="verbruik inschatten"
          ></wl-input-error>
        </div>
      }
    }
  </div>
  <div class="mb-2">
    @if (useAccessibleCalculator) {
      <crnt-form-control>
        <crnt-select>
          <select
            [wlTrackValueChange]="{
              step: 0.1,
              rendering: { componentName: 'verbruik inschatten' },
              label: 'type huis',
              inputLabel: formControls.houseType?.value | analyticsMap,
              sendValue: true,
              trackFocus: true,
              stepName: 'verbruik inschatten',
            }"
            [id]="formControls.houseType?.id"
            wlAutomationId="usageQuestionnaire.housingType"
            [ngrxFormControlState]="formControls.houseType"
          >
            @for (
              housingTypeOption of rendering?.housingTypeOptions;
              track housingTypeOption.value
            ) {
              <option [value]="housingTypeOption.value">
                {{ housingTypeOption.label }}
              </option>
            }
          </select>
          <crnt-icon icon="house" slot="leading"></crnt-icon>
        </crnt-select>
        <crnt-form-control-label slot="label">
          <label [for]="formControls.houseType?.id" class="fw-normal">
            {{ rendering?.housingTypeOptionsLabel }}
          </label>
        </crnt-form-control-label>
        @if (formControls.houseType | isInvalid) {
          <crnt-form-control-validation-message slot="validation">
            {{ rendering?.errorMessage }}
          </crnt-form-control-validation-message>
        }
      </crnt-form-control>
    } @else {
      <div class="mb-2">
        @if (rendering?.housingTypeOptionsLabel) {
          <label for="housingType">{{
            rendering?.housingTypeOptionsLabel
          }}</label>
        }
        <wl-dropdown
          [wlTrackValueChange]="{
            step: 0.1,
            rendering: { componentName: 'verbruik inschatten' },
            label: 'type huis',
            inputLabel: formControls.houseType?.value | analyticsMap,
            sendValue: true,
            trackFocus: true,
            stepName: 'verbruik inschatten',
          }"
          [dropdownItems]="rendering?.housingTypeOptions"
          [formsControl]="formControls.houseType"
          [placeholder]="rendering?.housingTypeOptionsPlaceHolder"
          [floatingLabel]="false"
          icon="house"
          labelForId="housingType"
          wlAutomationId="usageQuestionnaire.housingType"
        ></wl-dropdown>
      </div>
      @if (formControls.houseType | isInvalid) {
        <div class="col-12">
          <wl-input-error
            [messageField]="rendering?.errorMessage"
            messageDescription="type huis"
            [rendering]="rendering"
            stepName="verbruik inschatten"
          ></wl-input-error>
        </div>
      }
    }
  </div>
  @if (energyTypeDropdownShown) {
    <div class="mb-3" wlAutomationId="energy-type-dropdown">
      @if (useAccessibleCalculator) {
        <crnt-form-control>
          <crnt-select>
            <select
              [wlTrackValueChange]="{
                step: 0.1,
                rendering: { componentName: 'verbruik inschatten' },
                label: 'type aansluiting',
                inputLabel: formControls.supplyType?.value | analyticsMap,
                sendValue: true,
                trackFocus: true,
                stepName: 'verbruik inschatten',
              }"
              [id]="formControls.supplyType?.id"
              wlAutomationId="usageQuestionnaire.supplyType"
              [ngrxFormControlState]="formControls.supplyType"
            >
              @for (
                supplyTypeOption of rendering?.supplyTypeOptions;
                track supplyTypeOption.value
              ) {
                <option [value]="supplyTypeOption.value">
                  {{ supplyTypeOption.label }}
                </option>
              }
            </select>
            <crnt-icon icon="plug" slot="leading"></crnt-icon>
          </crnt-select>
          <crnt-form-control-label slot="label">
            <label [for]="formControls.supplyType?.id" class="fw-normal">
              {{ rendering?.supplyTypeOptionsLabel }}
            </label>
          </crnt-form-control-label>
          @if (formControls.supplyType | isInvalid) {
            <crnt-form-control-validation-message slot="validation">
              {{ rendering?.errorMessage }}
            </crnt-form-control-validation-message>
          }
        </crnt-form-control>
      } @else {
        <div class="mb-2">
          @if (rendering?.supplyTypeOptionsLabel) {
            <label for="supplyType">{{
              rendering?.supplyTypeOptionsLabel
            }}</label>
          }
          <wl-dropdown
            [wlTrackValueChange]="{
              step: 0.1,
              rendering: { componentName: 'verbruik inschatten' },
              label: 'type aansluiting',
              inputLabel: formControls.supplyType?.value | analyticsMap,
              sendValue: true,
              trackFocus: true,
              stepName: 'verbruik inschatten',
            }"
            [dropdownItems]="rendering?.supplyTypeOptions"
            [formsControl]="formControls.supplyType"
            [placeholder]="rendering?.supplyTypeOptionsPlaceHolder"
            [floatingLabel]="false"
            icon="plug"
            labelForId="supplyType"
            wlAutomationId="usageQuestionnaire.supplyType"
          ></wl-dropdown>
        </div>
        @if (formControls.supplyType | isInvalid) {
          <div class="col-12">
            <wl-input-error
              [messageField]="rendering?.errorMessage"
              messageDescription="type aansluiting"
              [rendering]="rendering"
              stepName="verbruik inschatten"
            ></wl-input-error>
          </div>
        }
      }
    </div>
  }
  @if (useAccessibleCalculator) {
    <crnt-button
      [fullWidth]="true"
      type="submit"
      wlAutomationId="usageQuestionnaire.submit"
    >
      {{ rendering?.submitLabel }}
    </crnt-button>
  } @else {
    <input
      type="submit"
      class="btn btn-primary text-center-ed w-100-ed"
      wlAutomationId="usageQuestionnaire.submit"
      [value]="rendering?.submitLabel"
    />
  }
</form>
